<template>
  <v-form ref="form" class="px-4" @submit.prevent="handleSave">
    <v-row>
      <v-col
          cols="12"
          md="2"
      >
        <v-autocomplete
            :menu-props="{ offsetY: true }"
            outlined
            :items="batchTypes"
            v-model="formData.type_batch"
            label="Typ"
            validate-on-blur
            :rules="[rules.required]"
            :item-text="(value) => value.description"
            :item-value="(value) => value.id"
        />
      </v-col>

      <v-col
          cols="12"
          md="2"
      >
        <v-select
            v-model="formData.type_commodity"
            :items="typeCommodityList"
            label="Typ komodity"
            :menu-props="{ offsetY: true }"
            outlined
            validate-on-blur
            :rules="[rules.required]"
            :item-text="(value) => `${value.description}`"
            :item-value="(value) => value.id"
        />
      </v-col>

      <v-col
          cols="12"
          md="2"
      >
        <v-select
            v-model="formData.commodity_purity"
            :items="getFilteredCommodityPurities(formData.type_commodity)"
            label="Ryzost"
            :menu-props="{ offsetY: true }"
            outlined
            validate-on-blur
            :rules="[rules.required]"
            :item-text="(value) => `${getFormattedPurityText(value)}`"
            :item-value="(value) => value.id"
        />
      </v-col>

      <v-col
          cols="12"
          md="2"
      >
        <v-text-field
            outlined
            label="Hmotnost"
            :rules="[rules.required]"
            validate-on-blur
            v-model="formData.weight"
            :max="this.weightLeft"
            :min="0"
            type="number"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{on}">
                <v-icon @click="appendMaxWeight" v-on="on">mdi-weight</v-icon>
              </template>
              <span>Maximální hmotnost</span>
            </v-tooltip>
          </template>
        </v-text-field>
      </v-col>
      <v-col
          cols="12"
          md="1"
      >
        <v-btn large class="aBtn--primaryInv" @click="getWeight()" :disabled="!isSerialPortApiAvailable()">
          Zvážit
        </v-btn>
      </v-col>
      <v-col
          cols="12"
          md="1"
      >
        <v-btn type="submit" large block class="primary">Uložit</v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import rules from '@/utils/rules.js'

import {createBuyoutBatchItem} from "@/components/batch/api";
import {getSerialPortData, isSerialPortApiAvailable} from "@/utils/serialport";
import {formattedPrice} from "@/utils/formatters";

export default {
  name: 'BuyoutBatchItemCreate',
  props: {
    item: {
      required: false, type: Object, default: () => {
      }
    }
  },
  data() {
    return {
      loading: false,
      isError: false,
      formData: {
        id: undefined,
        weight: undefined,
        type_batch: undefined,
        type_commodity: undefined,
        commodity_purity: undefined,
      },
      rules: {
        ...rules
      },
      batchTypes: [],
      batchItem: undefined,
      typeCommodityList: [],
      commodityPurities: []
    }
  },
  computed: {
    weightLeft() {
      return this.item ? this.item.weight_left : null
    },
  },
  async mounted() {
    this.loading = true
    this.batchTypes = await this.$store.dispatch('getBatchTypes')
    this.typeCommodityList = await this.$store.dispatch('getCommodityTypes')
    this.commodityPurities = await this.$store.dispatch('getCommodityPurities')
    this.batchItem = this.item
    if (this.item) {
      this.formData.type_commodity = this.item.type_commodity?.id
      this.formData.commodity_purity = this.item.commodity_purity?.id
    }
    this.loading = false
  },
  methods: {
    isSerialPortApiAvailable,
    async appendMaxWeight() {
      this.formData.weight = this.item.weight_left
    },

    async handleCreate(item) {
      createBuyoutBatchItem(item ? item.id : '', this.formData).then(() => {
        this.$emit('crateItem')
      })
    },
    getFilteredCommodityPurities(commodity_id) {
      if (commodity_id === null) {
        return []
      }
      let filtered_list = []
      this.commodityPurities.forEach(value => {
        if (value.type_commodity === commodity_id) {
          filtered_list.push(value)
        }
      })
      return filtered_list
    },
    handleSave() {
      const ok = this.$refs.form.validate()
      if (!ok) return

      this.handleCreate(this.item).then(() => {
        this.resetForm()
        this.$refs.form.resetValidation()
      })
    },
    resetForm() {
      this.formData = {
        id: undefined,
        description: undefined,
        weight: undefined,
        type_batch: undefined,
        image: undefined,
        type_commodity: undefined,
        commodity_purity: undefined,
      }
    },
    getWeight() {
      //TODO implement serial port weight  https://developer.mozilla.org/en-US/docs/Web/API/SerialPort
      return getSerialPortData()
    },
    getFormattedPurityText(commodityPurityItem) {
      return `${commodityPurityItem.purity} | ${formattedPrice(commodityPurityItem.price_for_gram)} Kč `
    }
  },
}

</script>